<template>
  <div class="main-div">
    <img class="mb-3" src="../assets/img/logo.png" />

    <div :class="{ 'login-div': !loggedInWithoutCode, 'code-div': loggedInWithoutCode }">
      <p class="mt-3 mb-3 text-center"> {{ (!loggedInWithoutCode) ?
        'Sign In to Your Account' : 'Authentication' }} </p>
      <b-form @submit.prevent="login('formLogin')" class="ml-4 mr-4 mb-4" data-vv-scope="formLogin">
        <div v-if="!loggedInWithoutCode">
          <b-form-group id="emailGroup">
            <b-form-input id="email" type="email" name="email" v-model="email" v-validate="'required|email'" :class="{
              'input': true,
              'is-danger': errors.has('formLogin.email')
            }" placeholder="Email">
            </b-form-input>
            <i v-show="errors.has('formLogin.email')" class="fa fa-warning"></i>
            <span v-show="errors.has('formLogin.email')" class="help is-danger">{{ errors.first('formLogin.email') }}
            </span>
          </b-form-group>
          <b-form-group id="passwordGroup">
            <b-form-input id="password" type="password" name="password" v-model="password" v-validate="'required|min:8'"
              :class="{
                'input': true,
                'is-danger': errors.has('formLogin.password')
              }" placeholder="Password">
            </b-form-input>
            <i v-show="errors.has('formLogin.password')" class="fa fa-warning"></i>
            <span v-show="errors.has('formLogin.password')" class="help is-danger">{{ errors.first('formLogin.password')
            }}
            </span>
          </b-form-group>
          <b-form-group id="forgot">
            <b-link @click="forgetPassword()" class="font-size" style="display:none;">Forgot Password?</b-link>
          </b-form-group>
        </div>
        <b-form-group v-else id="emailGroup">
          <b-form-text>
            Please enter the verification code from your email.
          </b-form-text>
          <b-form-input id="code" type="text" name="code" v-model="code" v-validate="'required'" :class="{
            'input': true,
            'is-danger': errors.has('formLogin.code')
          }" placeholder="Code">
          </b-form-input>
          <i v-show="errors.has('formLogin.code')" class="fa fa-warning"></i>
          <span v-show="errors.has('formLogin.code')" class="help is-danger">{{ errors.first('formLogin.code') }}
          </span>
        </b-form-group>
        <b-form-group id="buttonGroup">
          <b-row class="my-1" v-if="!loggedInWithoutCode">
            <b-col sm="6">
              <b-button type="submit" variant="warning">
                Sign In to Your Account
              </b-button>
            </b-col>
            <b-col sm="6">
              <b-button v-if="!loggedInWithoutCode" type="reset" @click="register()" class="w-100 btn-warning2" style="display:none;"
                variant="warning">Register Now</b-button>
            </b-col>
          </b-row>
          <b-row class="my-1" v-else>
            <b-col sm="12">
              <b-button type="submit" variant="warning" class="w-101">
                Verify
              </b-button>
            </b-col>
            <b-col>
            </b-col>
          </b-row>
        </b-form-group>
      </b-form>
    </div>

  </div>
</template>

<script>
import API from '@/api';
import Session from '@/Session';
import { detect } from 'detect-browser';

export default {
  name: 'Login',
  data() {
    return {
      email: null,
      password: null,
      code: null,
      loggedInWithoutCode: false,
      browsername: null,
      browserversion: null,
      browseros: null,
      accesscode: null,
    };
  },
  created() {
    const browser = detect();
    this.browsername = browser.name;
    this.browserversion = browser.version;
    this.browseros = browser.os;

    const customMessage = {
      custom: {
        email: {
          required: 'The Email Field is Required',
        },
        password: {
          required: 'The Password is Required',
        },
      },
    };
    this.$validator.localize('en', customMessage);
  },
  methods: {
    async login(scope) {
      try {
        const validation = await this.$validator.validateAll(scope);
        if (validation) {
          const emailAddress = this.email.toLowerCase()
          if (!this.loggedInWithoutCode) {
            const userCookieId = this.$cookie.get('idcloak_userid');
            const userCookieCode = this.$cookie.get('idcloak_usercode');
            const loginCode = await API.post('Accounts/sendLoginCode', {
              email: emailAddress,
              password: this.password,
              cookieId: userCookieId,
              cookieCode: userCookieCode,
              browserName: this.browsername,
              browserVersion: this.browserversion,
              browserOs: this.browseros,
            });
            if (loginCode.role == "admin" || loginCode.role == "subadmin") {
              if (loginCode.email === emailAddress && loginCode.twoFactor) {
                this.$cookie.set('idcloak_userid', `${loginCode.userId}`, { expires: 7 });
                if (loginCode.code) {
                  this.$cookie.set('idcloak_usercode', `${loginCode.code}`, { expires: '3Y' });
                }
                this.loggedInWithoutCode = true;
              } else if (loginCode.twoFactor) {
                this.loggedInWithoutCode = true;
              } else if (!loginCode.twoFactor) {
                Session.setAccessToken(loginCode);
                this.loggedInWithoutCode = false;
                if (loginCode.user.role === 'subadmin') {
                  this.$router.push('userDashboard');
                } else if (loginCode.user.address) {
                  this.$router.push('/');
                } else {
                  this.$router.push('/profile');
                }
              } else {
                Session.setAccessToken(loginCode);
                this.loggedInWithoutCode = false;
                if (loginCode.user.role === 'subadmin') {
                  this.$router.push('userDashboard');
                } else if (loginCode.user.address) {
                  this.$router.push('/');
                } else {
                  this.$router.push('/profile');
                }
              }
            }
            else {
              this.$notify({
                group: 'sitewide',
                title: 'Error!',
                type: 'error',
                text: 'Permission denied- Please contact Facit.',
              });
            }
          } else if (this.loggedInWithoutCode) {
            const loginWithCode = await API.post('Accounts/loginWithCode', {
              email: emailAddress,
              password: this.password,
              code: this.code,
            });
            Session.setAccessToken(loginWithCode);
			if (loginWithCode.user.role === 'subadmin') {
                  this.$router.push('userDashboard');
			}
            else if (loginWithCode.user.address) {
              this.$router.push('/');
            } else {
              this.$router.push('/profile');
            }
          }
        }
      } catch (error) {
        console.log(error);
        const message = error.response.data.error.message;
        if (message.match(/Email not verified/gi)) {
          this.$notify({
            group: 'sitewide',
            title: 'Error!',
            type: 'error',
            text: 'Email not verified',
          });
        } else if (message.match(/User not found/gi)) {
          this.$router.push('notification');
        } else if (message.match(/Sorry, but that email and password do not match!/gi)) {
          this.$notify({
            group: 'sitewide',
            title: 'Error!',
            type: 'error',
            text: 'Incorrect email or password',
          });
        } else if (message.match(/Invalid code/gi)) {
          this.$notify({
            group: 'sitewide',
            title: 'Error!',
            type: 'error',
            text: 'Invalid code!',
          });
        }else {
          this.$notify({
            group: 'sitewide',
            title: 'Error!',
            type: 'error',
            text: 'Sorry, Permission denied!',
          });
        }
      }
    },
    register() {
      this.$router.push('registration');
    },
    forgetPassword() {
      this.$router.push('forgetpassword');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main-div {
  background-color: #2c3e50;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  height: 100vh;
}

.login-div {
  background-color: white;
  width: 30%;
  height: 280px;
  border-radius: 3px;
  min-width: 440px;
}

.code-div {
  background-color: white;
  width: 30%;
  min-height: 215px;
  border-radius: 3px;
}

.w-100 {
  width: 160px;
}

.w-101 {
  width: 100%;
}

.font-size {
  font-size: 14px;
  color: grey;
}

.btn-warning {
  color: #fff;
  background-color: #ff8f00;
  border-color: #ff8f00;
}

.btn-warning2 {
  color: #fff;
  background-color: #db7a00;
  border-color: #db7a00;
}

.help.is-danger {
  color: #ff3860;
}

.help {
  display: block;
  font-size: 11px;
  margin-top: 5px;
}

span {
  font-style: inherit;
  font-weight: inherit;
}

*,
:after,
:before {
  box-sizing: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue